import React,{ useState } from "react";
import { Notify } from "../../Helpers/notification";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

export const CopyButton = ({ text, style={}, className="" }) => {
    const [copied, setCopied] = useState(false);
    
    const copyToClipboard = () => {
        navigator.clipboard.writeText(text)
            .then(() => {
                setCopied(true);
                setTimeout(() => {
                    setCopied(false);
                }, 2000);
            })
            .catch(err => {
                console.error('Failed to copy text: ', err);
                Notify.notify('Failed to copy text');
            });
    };
    if (!text) return null;
    
    return (
        <OverlayTrigger
            placement="top"
            overlay={copied ? <Tooltip>Copied!</Tooltip> : <Tooltip>Copy to clipboard</Tooltip>}
        >
            <Button
                variant="outline-secondary"
                size="sm"
                className={`position-absolute top-0 m-2 ${className}`}
                onClick={copyToClipboard}
                style={{ right: "26px", ...style}}
            >
                {copied ? <i className="fa fa-check"></i> : <i className="fa fa-copy"></i>}
            </Button>
        </OverlayTrigger>
    );
};